import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import academyCategoryApiController from "services/academycategory.service";
import HandleError from "../HandleError";
import HandleResponse from "../HandleResponse";
import {
  isContentReferenceListRequest,
  normalizeContentReferenceListResponse,
} from "../../services/contentContract";
import { contentErrorMessage } from "./contentError";


export const AcademyCategoryGridViewApi = createAsyncThunk("academy/academyGridview", async (formValues, thunkAPI) => {
  try {
    const resposedata = await academyCategoryApiController
      .view(formValues, thunkAPI)
      .then((response) => HandleResponse(thunkAPI, response, "academyview"))
      .catch((error) => HandleError(thunkAPI, error, "academy/view"));
    return resposedata;
  } catch (error) {
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    return thunkAPI.rejectWithValue(message);
  }
});


const initialState = {
  isGridView: [],
  isGridViewError: "",
  isApiStatus: {
    AcademyCategoryGridViewApi: "",
  },
};

const academycategorySlice = createSlice({
  name: "academycategory",
  initialState,
  reducers: {
    reset: () => initialState,

  },
  extraReducers: (builder) => {
    builder
      .addCase(AcademyCategoryGridViewApi.pending, (state) => {
        state.isApiStatus = { ...state.isApiStatus, AcademyCategoryGridViewApi: "loading" };
        state.isGridViewError = "";
      })
      .addCase(AcademyCategoryGridViewApi.fulfilled, (state, action) => {
        const response = isContentReferenceListRequest(action.meta.arg)
          ? normalizeContentReferenceListResponse(action.payload)
          : action.payload;
        let old_current_page = state.isGridView.current_page || "";
        let new_current_page = response.current_page || "";
        let viewdata = state.isGridView && state.isGridView.data;
        let newviewdata = response && response.data;
        state.isGridView = response;
        if (old_current_page && new_current_page && old_current_page < new_current_page && old_current_page !== new_current_page) {
          viewdata && newviewdata ? (state.isGridView.data = [...viewdata, ...newviewdata]) : response;
        }
        state.isGridViewError = "";
        state.isApiStatus = { ...state.isApiStatus, AcademyCategoryGridViewApi: "succeeded" };
      })
      .addCase(AcademyCategoryGridViewApi.rejected, (state, action) => {
        state.isApiStatus = { ...state.isApiStatus, AcademyCategoryGridViewApi: "failed" };
        state.isGridViewError = contentErrorMessage(action, "Unable to load academy categories.");
      });
  },
})



// Action creators are generated for each case reducer function
export const { reset } = academycategorySlice.actions;
export default academycategorySlice.reducer;
